import { useMemo } from 'react'
import { Linking } from 'react-native'

import { i18n } from '@zet/localization'

import { creditCard, loansIMG, offersIMG } from '../../assets'

const useBenefitsData = () => {
  const local = i18n.locale
  const benefitsData = useMemo(
    () => [
      {
        id: 'id-1',
        title: i18n.t('checkCreditScore.lowerInterestRate.heading'),
        subTitle: i18n.t('checkCreditScore.lowerInterestRate.subHeading'),
        imageSource: offersIMG,
      },
      {
        id: 'id-2',
        title: i18n.t('checkCreditScore.bestCreditCard.heading'),
        subTitle: i18n.t('checkCreditScore.bestCreditCard.subHeading'),
        imageSource: creditCard,
      },
      {
        id: 'id-3',
        title: i18n.t('checkCreditScore.bestLoans.heading'),
        subTitle: i18n.t('checkCreditScore.bestLoans.subHeading'),
        imageSource: loansIMG,
      },
    ],
    [local]
  )
  return { benefitsData }
}

const CREDIT_SCORE_DATA = ['Excellent', 'High', 'Medium', 'Low']

const cardType = (
  creditScoreLevel: 'Excellent' | 'High' | 'Medium' | 'Low',
  bureau: 'EXPERIAN' | 'CRIF'
) => {
  switch (creditScoreLevel) {
    case 'Excellent':
      return {
        bgColor: 'bg-[#D4FFE6]',
        Icon: 'CreditScoreExcellent',
        score: bureau === 'CRIF' ? '750+' : '750+',
      }
    case 'High':
      return {
        bgColor: 'bg-[#EAF3FF]',
        Icon: 'CreditScoreHigh',
        score: bureau === 'CRIF' ? '700-750' : '700-750',
      }
    case 'Medium':
      return {
        bgColor: 'bg-[#FFF5DE]',
        Icon: 'CreditScoreMedium',
        score: bureau === 'CRIF' ? '500-700' : '500-700',
      }
    default:
      return {
        bgColor: 'bg-[#FFEAEA]',
        Icon: 'CreditScoreLow',
        score: bureau === 'CRIF' ? '<500' : '<500',
      }
  }
}

const handleShareWhatsapp = (message: string) => {
  Linking.openURL(`whatsapp://send?text=${message}`)
}

const handleShareMessage = (message: string) => {
  Linking.openURL(`sms:?body=${message}`)
}

const handleShareTelegram = (message: string) => {
  Linking.openURL(`https://telegram.me/share/url?url=${message}`)
}

const getCreditLevel = (report: number, bureau: string) => {
  const isExperian = bureau === 'EXPERIAN'
  if (isExperian) {
    if (report >= 750) {
      return i18n.t('checkCreditScore.excellent')
    } else if (report >= 700) {
      return i18n.t('checkCreditScore.high')
    } else if (report >= 601) {
      return i18n.t('checkCreditScore.medium')
    } else {
      return i18n.t('checkCreditScore.low')
    }
  } else {
    if (report > 749) {
      return i18n.t('checkCreditScore.excellent')
    } else if (report > 649) {
      return i18n.t('checkCreditScore.high')
    } else if (report > 549) {
      return i18n.t('checkCreditScore.medium')
    } else {
      return i18n.t('checkCreditScore.low')
    }
  }
}

const FAQS_DATA = Object.keys(i18n.t('creditScoreFaq')).map((value) => {
  return {
    question: i18n.t(`creditScoreFaq.${[value]}.question`),
    answer: i18n.t(`creditScoreFaq.${[value]}.answer`),
  }
})

export {
  cardType,
  CREDIT_SCORE_DATA,
  FAQS_DATA,
  getCreditLevel,
  handleShareMessage,
  handleShareTelegram,
  handleShareWhatsapp,
  useBenefitsData,
}
